import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocCasesService } from '../../../core/services/doc-cases.service';
import { IDocCase } from '../../../core/models/documentCase.modal';
import { OrderSelectionService } from '../../../core/services/order-selection.service';
import { GetCountryDocuments } from '../../../core/services/get-country-documents';

@Component({
    selector: 'app-corporate-docs-table',
    imports: [CommonModule],
    templateUrl: './corporate-docs-table.html',
    styleUrl: './corporate-docs-table.scss',
})
export class CorporateDocsTable implements OnInit {
    private docCasesService = inject(DocCasesService);
    private cdr = inject(ChangeDetectorRef);
    private getCountryDocsService = inject(GetCountryDocuments);
    orderSelection = inject(OrderSelectionService);

    docCases: IDocCase[] = [];
    isLoading = true;
    corpDocsAcceptDigital: IDocCase[] = [];
    corpDocsAcceptPhysicalNotary: IDocCase[] = [];
    corpDocsNotAccept: IDocCase[] = [];

    totalFee: number | null = null;
    totalTime: number | null = null;

    hasDigitalOrder = false;

    async ngOnInit() {
        await this.docCasesService.loadDocCases();
        this.docCases = this.docCasesService.docCases;
        // this.corpDocs = this.docCases.filter(doc => doc.type === 'corporate');
        this.corpDocsAcceptDigital = this.docCases.filter(doc => doc.is_digital_accepted && !doc.is_physical_notary_required && doc.is_active && doc.type === 'corporate');
        this.corpDocsAcceptPhysicalNotary = this.docCases.filter(doc => doc.is_digital_accepted && doc.is_physical_notary_required && doc.is_active && doc.type === 'corporate');
        this.corpDocsNotAccept = this.docCases.filter(doc => !doc.is_digital_accepted && !doc.is_physical_notary_required && doc.is_active && doc.type === 'corporate');

        this.isLoading = false;

        if (typeof localStorage !== 'undefined') {
            const savedCart = localStorage.getItem('cart_response');
            if (savedCart) {
                try {
                    const cart = JSON.parse(savedCart);
                    const orderType = cart.data?.orderType || cart.orderType;
                    if (orderType === 'Digital') {
                        this.hasDigitalOrder = true;
                    }
                } catch (e) {}
            }
        }

        // Check if server-side fetched prices are already available in service signal
        const priceData = this.getCountryDocsService.latestServicePrices();
        if (priceData) {
            this.totalFee = Number(priceData.totalPrice);
            this.totalTime = parseInt(priceData.totalDays, 10);
        } else {
            this.fetchPrices();
        }

        this.cdr.detectChanges();
    }

    private async fetchPrices() {
        if (typeof document === 'undefined') return;
        const hiddenInput = document.querySelector<HTMLInputElement>('input.orderId');
        if (hiddenInput) {
            const orderId = Number(hiddenInput.dataset['id']);
            const dotNetCountryId = Number(hiddenInput.dataset['dotnetcountryid']);
            
            try {
                const priceData = await this.getCountryDocsService.fetchServicePricesIfNeeded(orderId, dotNetCountryId);
                if (priceData) {
                    this.totalFee = Number(priceData.totalPrice);
                    this.totalTime = parseInt(priceData.totalDays, 10);
                    this.cdr.detectChanges();
                }
            } catch (error) {
                console.error('[CorporateDocsTable] Error loading prices:', error);
            }
        }
    }

    onCheckboxChange(doc: IDocCase, event: Event) {
        const checked = (event.target as HTMLInputElement).checked;
        if (checked && !doc.is_digital_accepted && this.hasDigitalOrder) {
            alert("You must end your digital order first to do this.");
            (event.target as HTMLInputElement).checked = false;
            return;
        }
        this.orderSelection.toggleDoc(doc, checked);
    }

    increment(doc: IDocCase) {
        if (!doc.is_digital_accepted && this.hasDigitalOrder) {
            alert("You must end your digital order first to do this.");
            return;
        }
        const currentQty = this.orderSelection.getQuantity(doc.id);
        if (currentQty === 0) {
            this.orderSelection.toggleDoc(doc, true);
        } else {
            this.orderSelection.setQuantity(doc.id, currentQty + 1);
        }
    }

    decrement(doc: IDocCase) {
        const currentQty = this.orderSelection.getQuantity(doc.id);
        if (currentQty > 1) {
            this.orderSelection.setQuantity(doc.id, currentQty - 1);
        } else if (currentQty === 1) {
            this.orderSelection.toggleDoc(doc, false);
        }
    }

    showCaseContent(data: any){
        
    }
}
